<section class="rating-section pt-5 pb-5" id="ratingReviewId">
    <div class="">
        <h2 class="page-sub-title cv-text-dark mb-4">Rating and Reviews</h2>
        <div class="row gy-5">
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
                <div class="row align-items-center">
                    <!--rating star-->
                    <div class="col-5 col-sm-5 col-md-5 col-lg-4 col-xl-4">
                        <div class="total-rating">
                            {{ totalRating }}

                            <img [src]="environment1 + 'images/new-images/star.svg'" style="width: 25%;" alt="star" loading="lazy">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15"
                            fill="none">
                            <path
                                d="M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z"
                                fill="#FDC602" />
                        </svg> -->
                            <br />

                        </div>
                        <div class="total-rating-desc">
                            <span class="text-center">
                                {{ ratingList?.length ? ratingList?.length : 0 }} Rating <br />
                                and {{descriptionCount}} review
                            </span>

                        </div>
                    </div>
                    <!--rating progress bar-->
                    <div class="col-7 col-sm-7 col-md-7 col-lg-8 col-xl-8">
                        <div class="rating-progress-bar">
                            <div class="total-rated-star">
                                5
                                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
                            </div>
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width':getRatingValue(fiveStarRatingCount)}"
                                    aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="total-rated">
                                {{ fiveStarRatingCount }}
                            </div>
                        </div>
                        <div class="rating-progress-bar">
                            <div class="total-rated-star">
                                4
                                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
                            </div>
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width':getRatingValue(fourStarRatingCount)}"
                                    aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="total-rated">
                                {{ fourStarRatingCount }}
                            </div>
                        </div>
                        <div class="rating-progress-bar">
                            <div class="total-rated-star">
                                3
                                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
                            </div>
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width':getRatingValue(threeStarRatingCount)}"
                                    aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="total-rated">
                                {{ threeStarRatingCount }}
                            </div>
                        </div>
                        <div class="rating-progress-bar">
                            <div class="total-rated-star">
                                2
                                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
                            </div>
                            <div class="progress">
                                <div class="progress-bar bg-warning" role="progressbar" [ngStyle]="{'width':getRatingValue(twoStarRatingCount)}"
                                    aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="total-rated">
                                {{ twoStarRatingCount }}
                            </div>
                        </div>
                        <div class="rating-progress-bar">
                            <div class="total-rated-star">
                                1
                                <img style="margin-left: 5px;" [src]="environment1 + 'images/new-images/star.svg'"  alt="star" loading="lazy">
                            </div>
                            <div class="progress">
                                <div class="progress-bar bg-danger" role="progressbar" [ngStyle]="{'width':getRatingValue(oneStarRatingCount)}"
                                    aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="total-rated">
                                {{ oneStarRatingCount }}
                            </div>
                        </div>
                    </div>
                    <!--rating circle chart-->
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-5">
                        <div class="row row-cols-4">
                            <div class="col text-center">
                                <circle-progress [percent]="safety" [radius]="100"></circle-progress>
                                <div class="text-center">
                                    Safety
                                </div>
                            </div>
                            <div class="col">
                                <circle-progress [percent]="performance" [radius]="100"></circle-progress>
                                <div class="text-center">
                                    Performance
                                </div>
                            </div>
                            <div class="col">
                                <circle-progress [percent]="design" [radius]="100"></circle-progress>
                                <div class="text-center">
                                    Design
                                </div>
                            </div>
                            <div class="col">
                                <circle-progress [percent]="comfort" [radius]="100"></circle-progress>
                                <div class="text-center">
                                    Comfort
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--buttons-->
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngIf="ratingList?.length !== 0">
                        <button type="button"
                            class="btn text-nowrap btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"
                            data-toggle="tooltip" data-placement="top" title="Click here to View all review"
                            (click)="writeReview('view')">View all review</button>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngIf="ratingList?.length !== 0">
                        <button type="button" class="btn text-nowrap btn-primary btn-lg btn-grad-primary btn-brand w-100"
                        data-toggle="tooltip" data-placement="top" title="Click here to Write a review"
                            (click)="writeReview('write')">Write a review</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-7 offset-lg-1 col-lg-6 col-xl-6">
                <!--review -->
                <div class="row mb-4" *ngFor="let item of ratingList">
                    <div class="col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                        <div class="user-info">
                            <div class="rating">
                                <ng-container *ngFor="let rating of item.rating_master">

                                    <ngx-stars *ngIf="rating.parameter == 'overall'" [readonly]="true"
                                        [customStarIcons]="heartUrls" [color]="'#FDC602'" [initialStars]="rating.rating"
                                        [size]="5"></ngx-stars>
                                </ng-container>

                            </div>
                            <div class="user-name">
                                {{item?.first_name}}&nbsp; {{item?.last_name}}
                            </div>
                            <div class="time">
                                {{item.updated_date | dateAgo}}
                            </div>
                        </div>
                    </div>
                    <div class="col-8 col-sm-8 col-md-8 col-lg-9 col-xl-9">
                        <div class="review">
                            <h3>{{item.title}}</h3>
                            <p>
                                {{item.description}}
                            </p>
                            <div class="review-image-vedio-wrapper" *ngFor="let images of item.image">
                                <div class="img">
                                    <img class="img-fluid" [src]="images" loading="lazy"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--no review-->
                <div class="row align-items-center" *ngIf="ratingList?.length == 0">
                    <div class="col-12">
                        <div class="no-rating-frame">
                            <div class="text-center  mb-3">
                                <img [src]="environment1 + 'images/new-images/rating.svg'" alt="rating" loading="lazy">
                            </div>
                            <div class="text-center no-customer-rating-text">
                                There are no customer ratings or review for this product.
                            </div>
                            <div class="d-block d-lg-flex align-items-center">
                                <div class="no-rating-content">
                                    <h4>Be the first one to review this product</h4>
                                    <p class="mb-0">Share your thoughts with other customers</p>
                                </div>
                                <div class="ms-auto mt-3 mt-lg-0 w-50">
                                    <button type="button"
                                        class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
                                        data-toggle="tooltip" data-placement="top" title="Click here to Write a review"
                                        (click)="writeReview('write')">Write a review</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #productReview let-d="dismiss4">
    <app-product-review [data]="productReviewData"></app-product-review>
</ng-template>
